<li :class="{ 'aplayer-list-light': active }" @click="$emit('click')">
  <span class="aplayer-list-cur" :style="`background: ${theme}`"></span>
  <span class="aplayer-list-index">{{ index }}</span>
  <span class="aplayer-list-title">{{ title }}</span>
  <span class="aplayer-list-author">{{ author }}</span>
</li>



// WEBPACK FOOTER //
// ./src/components/Item/src/Item.html